/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect, memo, useMemo } from "react";
import picturePlaceHolder from "../../../assets/images/picture_placeholder.svg";
import { useAuth } from "../../../context/AuthContext";
import dropdownArrow from "../../../assets/images/chevron-down.svg";
import { useMPSEventRegistration } from "../../../context/MPSEventRegistrationContext";
import ModalLoadingState from "../../PopUpModal/ModalLoadingState";
import { MARKETPLACE_SELLER_TYPES } from "../../../constants/constants";
import FilesCard from "../../Files/FilesCard";
import SocialMediaHandles from "../../SocialMediaHandles/SocialMediaHandles";
import Button from "../../ui/Button";
import fileUploadCloud from "../../../assets/images/fileupload_cloud.svg";
import document_icon from "../../../assets/images/upload_document.svg";
import FormField from "../../ui/FormField";
import { validateEmail, validatePhoneNumber } from "../../../utils/validations";

const MPSEventRegistration1 = ({
  handleContinue,
  handleCancel,
  handleSave,
  mpsEventRegistrationInfo,
  setMPSEventRegistrationInfo,
}) => {
  const { user } = useAuth();
  const MPSProfileID = user.uid;
  const marketplaceSellerTypes = MARKETPLACE_SELLER_TYPES;
  const { MPSEventRegistrationData, updateMPSEventRegistration } =
    useMPSEventRegistration();
  const [isLoading, setIsLoading] = useState(false);

  const initialState = {
    companyLogo: MPSEventRegistrationData.companyLogoURL || "",
    companyLogoPreview: picturePlaceHolder,
    businessName: MPSEventRegistrationData.businessName || "",
    fullName: MPSEventRegistrationData.fullName || "",
    email: MPSEventRegistrationData.email || "",
    phoneNumber: MPSEventRegistrationData.phoneNumber || "",
    description: MPSEventRegistrationData.description || "",
    typeOfBusiness: MPSEventRegistrationData.typeOfBusiness || "",
    SMScontact: MPSEventRegistrationData.SMScontact || "",
    website: MPSEventRegistrationData.website || "",
    socialMediaLinks: MPSEventRegistrationData.socialMediaLinks || {},
    documents: MPSEventRegistrationData.documents || [],
  };
  const [formState, setFormState] = useState(initialState);
  const [isEdit, setIsEdit] = useState(false);
  const [errors, setErrors] = useState({});


  useEffect(() => {
    if (mpsEventRegistrationInfo) {
      setFormState((prev) => ({
        ...prev,
        ...mpsEventRegistrationInfo,
        companyLogoPreview:
          mpsEventRegistrationInfo.companyLogoURL || picturePlaceHolder,
      }));
    }
  }, [mpsEventRegistrationInfo]);

  const handleFieldChange = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  const handleSocialChange = (platform, value) => {
    setFormState((prev) => ({
      ...prev,
      socialMediaLinks: { ...prev.socialMediaLinks, [platform]: value },
    }));
  };

  const handleValidation = (field, value) => {
    if (field === "email") {
      if (value && !validateEmail(value)) {
        setErrors((prev) => ({
          ...prev,
          email: "Please enter a valid email address",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors.email;
          return newErrors;
        });
      }
    }
    if (field === "phoneNumber" || field === "SMScontact") {
      if (value && !validatePhoneNumber(value)) {
        setErrors((prev) => ({
          ...prev,
          phone: "Please enter a valid phone number",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors.phone;
          return newErrors;
        });
      }
    }
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormState((prev) => ({
        ...prev,
        companyLogo: file,
      }));
    }
  };

  const handleSaveChanges = async () => {
    const response = await updateMPSEventRegistration({ ...formState });
    setMPSEventRegistrationInfo(response);
    setMPSEventRegistrationInfo(initialState)
    handleSave(response);
  };

  const formFields = [
    {
      label: "Business Name",
      name: "businessName",
      value: formState.businessName,
      placeholder: "Enter your business name",
      type: "text",
      error: null,
    },
    {
      label: "Business Type",
      name: "typeOfBusiness",
      value: formState.typeOfBusiness,
      type: "select",
      options: marketplaceSellerTypes,
    },
    {
      label: "Primary Contact Full Name",
      name: "fullName",
      value: formState.fullName,
      placeholder: "Full name",
      type: "text",
      error: null,
    },
    {
      label: "Business Phone Number",
      name: "phoneNumber",
      value: formState.phoneNumber,
      placeholder: "+1 234 567 8910",
      type: "text",
      error: errors.phone,
    },
    {
      label: "Email Address",
      name: "email",
      value: formState.email,
      placeholder: "example@email.com",
      type: "email",
      error: errors.email,
    },
    {
      label: "SMS Contact Number",
      name: "SMScontact",
      value: formState.SMScontact,
      placeholder: "+1 234 567 8910",
      type: "text",
      error: errors.phone,
    },
  ];

  const handleFileUpload = (event) => {
    const files = event.target.files;
    const newDocuments = Array.from(files).map((file) => ({
      fileName: file.name,
      file: file,
    }));

    setFormState((prev) => ({
      ...prev,
      documents: [...prev.documents, ...newDocuments],
    }));
  };
  const handleFileRemove = (index) => {
    setFormState((prev) => ({
      ...prev,
      documents: prev.documents.filter((_, i) => i !== index),
    }));
  };
  return (
    <>
      {isLoading ? (
        <ModalLoadingState />
      ) : (
        <div className="flex flex-col w-full h-full gap-6 p-3 sm:p-6">
          <div>
            <h2 className="text-lg font-semibold text-grey-900">Business Information</h2>
            <p className="text-sm text-grey-500 mt-1">Pre-filled from your profile — review and edit if needed before sending to the organizer.</p>
          </div>
          <div className="space-y-1">
            <label className="block text-sm font-medium text-grey-700">Company Logo</label>
            {formState.companyLogo && formState.companyLogo !== picturePlaceHolder ? (
              <img
                className="rounded-lg h-20 w-20 object-cover border border-grey-200"
                src={
                  formState.companyLogo instanceof File
                    ? URL.createObjectURL(formState.companyLogo)
                    : formState.companyLogo
                }
                alt="Logo Preview"
              />
            ) : (
              <div className="h-20 w-20 rounded-lg bg-grey-100 border border-grey-200 flex items-center justify-center text-grey-400 text-xs">
                No logo
              </div>
            )}
            {isEdit && (
              <>
                <label
                  htmlFor="company-logo-upload"
                  className="block mt-2 font-medium underline cursor-pointer text-grey-900 underline-offset-4"
                >
                  Upload Company Logo
                </label>
                <input
                  id="company-logo-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleLogoUpload}
                  className="hidden"
                />
              </>
            )}
          </div>
          {/* Business Details */}
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6">
            {formFields.map((field, index) => (
              <FormField
                key={index}
                field={field}
                isEdit={isEdit}
                handleFieldChange={handleFieldChange}
              />
            ))}
          </div>

          <div className="w-full space-y-6">
            {/* About */}
            <FormField
              field={{
                label: "About",
                name: "description",
                value: formState.description,
                placeholder: "Enter a description about your business",
                type: "textarea",
              }}
              isMultiple={true}
              isEdit={isEdit}
              handleFieldChange={handleFieldChange}
            />

            {/* Business Documents */}
            <div className="flex items-center gap-2 text-base font-medium">
              <div className="pt-4 pb-4 mb-4">
                <span className="font-medium text-md text-grey-900">
                  Business Documents
                </span>
                {isEdit ? <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8">
                  <div className="flex items-center justify-center">
                    <div className="flex w-auto bg-grey-25 items-center justify-center">
                      <label
                        htmlFor="file-upload"
                        className="flex flex-col items-center justify-center w-full py-4 border-2 border-dashed border-grey-300 rounded-lg cursor-pointer hover:border-grey-500 p-6"
                      >
                        <img src={fileUploadCloud} alt="fileUploadCloud" />
                        <div className="flex flex-col items-center justify-center pt-5 pb-6 gap-2">
                          <p className="mb-2 text-sm text-grey-900">
                            <span className="font-medium whitespace-nowrap">
                              Upload documents here
                            </span>
                          </p>
                        </div>
                        <input
                          id="file-upload"
                          type="file"
                          className="hidden"
                          onChange={handleFileUpload}
                          multiple
                        />
                      </label>
                    </div>
                  </div>
                  {formState?.documents.map((document, index) => (
                    <div key={index} className="border border-grey-300 rounded-2xl p-8 flex flex-col items-center justify-center">
                      <img
                        src={document_icon}
                        alt=""
                        className="h-[40px] w-[40px]"
                      />
                      <p className="pt-2 text-sm font-medium text-success-700 whitespace-nowrap">
                        {document?.fileName.length > 15
                          ? `${document.fileName.slice(0, 15)}...`
                          : document.fileName}
                      </p>
                      <button
                        onClick={() => handleFileRemove(index)}
                        className="px-6 py-3 text-error-700 text-sm font-medium underline underline-offset-4"
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div> : <div className="flex flex-col gap-4 mt-4 sm:flex-row">
                  <FilesCard filesData={formState.documents} />
                </div>}
              </div>
            </div>
            { }

            {/* Website and Social Media */}
            <div className="mx-auto mb-8">
              <div className="flex flex-col gap-8 lg:flex-row md:gap-10 lg:gap-28">
                {/* Left Section - Website */}
                <FormField
                  field={{
                    label: "Website",
                    name: "website",
                    value: formState.website,
                    placeholder: "Enter your business website URL",
                    type: "text",
                  }}
                  isEdit={isEdit}
                  handleFieldChange={handleFieldChange}
                />

                {/* Right Section - Social Media */}
                <div className="flex-auto space-y-8 lg:w-64 md:w-full">
                  <div className="flex items-center gap-2 text-base font-medium">
                    <div>
                      <span className="font-medium text-md text-grey-900">
                        Social Media
                      </span>
                      {!isEdit ? (
                        <p className="text-sm font-normal text-grey-700 mt-1">
                          {formState.socialMediaLinks && (
                            <SocialMediaHandles
                              handles={formState.socialMediaLinks}
                            />
                          )}
                        </p>
                      ) : (
                        <div className="mt-2 space-y-2">
                          {[
                            { platform: "instagram", label: "Instagram", placeholder: "@yourbusiness" },
                            { platform: "facebook", label: "Facebook", placeholder: "YourPageName" },
                            { platform: "tiktok", label: "TikTok", placeholder: "@yourbusiness" },
                            { platform: "twitter", label: "X / Twitter", placeholder: "@yourbusiness" },
                          ].map(({ platform, label, placeholder }) => (
                            <div key={platform} className="flex items-center gap-2">
                              <span className="text-xs text-grey-500 w-20 flex-shrink-0">{label}</span>
                              <input
                                type="text"
                                value={formState.socialMediaLinks?.[platform] || ""}
                                onChange={(e) => handleSocialChange(platform, e.target.value)}
                                placeholder={placeholder}
                                className="flex-1 text-sm border border-grey-300 rounded-md px-2 py-1 focus:outline-none focus:ring-1 focus:ring-primary-500"
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row justify-end items-stretch sm:items-center gap-3 sm:gap-6 mt-6">
            {!isEdit ? (
              <>
                <Button variant="underline" onClick={() => setIsEdit(true)}>
                  Edit my Information
                </Button>
                <Button variant="transparent" onClick={handleCancel}>
                  Cancel Application
                </Button>
                <Button onClick={handleContinue}>Continue</Button>
              </>
            ) : (
              <>
                <Button variant="underline" onClick={() => setIsEdit(false)}>
                  Cancel
                </Button>
                <Button onClick={handleSaveChanges}>Save Changes</Button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default MPSEventRegistration1;
